import styled from 'styled-components';

export const Contents = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ContentsHeader = styled.div`
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;

  & > span {
    display: flex;
    font-size: 11px;
  }
`;

export const Player = styled.span`
  box-sizing: border-box;
  justify-content: flex-start;
  width: 119px;
  min-width: 119px;
  padding-left: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Row = styled.span`
  flex: 1;
  justify-content: center;
  text-align: center;
`;

export const List = styled.ul`
  display: flex;
  flex-direction: column;
`;

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  height: 36px;
  width: 100%;
  border-bottom: 1px solid #f2f2f2;
  &.noneBorder {
    border: none;
  }
  span {
    font-size: 13px;
  }
`;

export const Empty = styled.li`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border-bottom: none;
`;
